





































































































































import FooterButton from "@/components/FooterButton.vue";
import { Component, Mixins } from "vue-property-decorator";
import { AppData, INCOME_RANGE } from "@/models/app-data";
import CommonMixin, { County } from "@/mixins/common-mixins";
import { ContentService } from "@/service/content.service";
import { AlternateHSQualifierUnder4Content } from "@/models/content/alternate-hs-qualifier-under-4";
import { QualifierRule, matchQualifiers } from "@/models/rules";

@Component({
  components: {
    FooterButton,
  },
})
export default class AlternateHSQualifierUnder4 extends Mixins(CommonMixin) {
  content: AlternateHSQualifierUnder4Content = {} as AlternateHSQualifierUnder4Content;
  PercentDone = 80;
  fosterChecked = false;
  homelessChecked = false;
  benefitsChecked = false;
  noneChecked = false;
  appData = {} as AppData;
  textDirection = "ltr";
  checkTextAlign = "has-text-left";

  async mounted(): Promise<void> {
    try {
      const contentService = new ContentService(this.$route);
      this.content = await contentService.getAlternateHSQualifierUnder4Content();
      this.textDirection = contentService.TextDirection();
      if (this.textDirection == "rtl") {
        this.checkTextAlign = "has-text-right";
      }
      this.appData = this.getAppData();

      if (this.appData != null) {
        this.fosterChecked = this.appData.foster;
        this.benefitsChecked = this.appData.benefits;
        this.homelessChecked = this.appData.homeless;
        this.noneChecked = this.appData.hsQualifierUnder4None;
        this.putWorkflowStep( this.appData.workflowId, "AlternateHSQualifierUnder4") 
      }
    } catch (error) {
        this.showError(error as any);
    }
  }

  optionChanged(e: { target: HTMLInputElement }): void {
    if (this.noneChecked === true) {
      this.noneChecked = false;
    }
  }

  noneChanged(e: { target: HTMLInputElement }): void {
    if (this.noneChecked == true) {
      this.fosterChecked = false;
      this.homelessChecked = false;
      this.benefitsChecked = false;
    }
  }
  public oneOrMoreApplies(): boolean {
    return (
      this.fosterChecked === true ||
      this.homelessChecked === true ||
      this.benefitsChecked === true
    );
  }

  public handleNextPageEvent(): void {
    if (this.appData == null) {
      this.appData = {} as AppData;
    }
    this.appData.foster = this.fosterChecked;
    this.appData.benefits = this.benefitsChecked;
    this.appData.homeless = this.homelessChecked;
    this.appData.hsQualifierUnder4None = this.noneChecked;

    const oneOrMoreApplies =
      this.fosterChecked ||
      this.homelessChecked ||
      this.benefitsChecked;

    if (oneOrMoreApplies === true) {
      this.clearGSRPQualifiers(this.appData);
      this.clearGSRPQualifiersList2(this.appData);
      this.clearHSQualifierList2(this.appData)
      this.clearHSQualifierList3(this.appData)
    }

    this.saveAppData(this.appData);

    this.handleBothUnderAndOverFour();
  }

  handleBothUnderAndOverFour(): void {
    const rules: QualifierRule[] = [
        { index: [true, County.Wayne, undefined], path: 'MatchHSAndGSRPReferral' }
       ,{ index: [true, County.Macomb, undefined], path: 'MatchHSAndGSRPReferral' }
       ,{ index: [true, County.Oakland, undefined], path: 'MatchHSAndGSRPReferral' }
       ,{ index: [true, County.Washtenaw, undefined], path: 'MatchHSAndGSRPReferral' }
       ,{ index: [false, County.Washtenaw, INCOME_RANGE.FPL_LVL_1_TO_LVL_2], path: 'MatchNoneCDCLikelyAndGSRPReferral' }
       ,{ index: [false, County.Washtenaw, INCOME_RANGE.FPL_LVL_2_TO_LVL_3], path: 'MatchNoneAndGSRPReferral' }
       ,{ index: [false, County.Washtenaw, INCOME_RANGE.FPL_LVL_3_PLUS], path: 'MatchNoneAndGSRPReferral' }
       ,{ index: [false, County.Oakland, INCOME_RANGE.FPL_LVL_1_TO_LVL_2], path: 'MatchNoneCDCLikelyAndGSRPReferral' }
       ,{ index: [false, County.Oakland, INCOME_RANGE.FPL_LVL_2_TO_LVL_3], path: 'MatchNoneAndGSRPReferral' }
       ,{ index: [false, County.Oakland, INCOME_RANGE.FPL_LVL_3_PLUS], path: 'MatchNoneAndGSRPReferral' }
       ,{ index: [false, County.Wayne, undefined], path: 'AlternateHSQualifierUnder4List2' }
       ,{ index: [false, County.Macomb, undefined], path: 'AlternateHSQualifierUnder4List2' }
    ]

    const rule = matchQualifiers(rules, this.oneOrMoreApplies(), this.appData.county, this.appData.fpl)
    if (rule == null) {
        this.$router.push({ path: 'MatchNone' });
            return;
    }
    this.$router.push({ path: rule.path });
  }

  disableNext(): boolean {
    return !(
      this.fosterChecked ||
      this.homelessChecked ||
      this.benefitsChecked ||
      this.noneChecked
    );
  }
}
